"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Request = require("./_request-api");
var User = require("./user");
var constants_1 = require("../data/constants");
var all = function (page, expertId) {
    if (page === void 0) { page = 1; }
    if (expertId === void 0) { expertId = null; }
    var endpoint = expertId ? constants_1.endpoints.api + "/experts/" + expertId + "/ratings" : constants_1.endpoints.api + "/ratings";
    return Request.sendGet(endpoint, {
        page: page,
    });
};
exports.all = all;
var create = function (purchase, note, content) {
    if (content === void 0) { content = null; }
    return Request.sendPost(constants_1.endpoints.api + "/ratings", {
        note: note,
        purchase_id: purchase,
        content: content,
    })
        .then(function (rating) {
        User.current({ forceFetch: true });
        return rating;
    });
};
exports.create = create;
//# sourceMappingURL=rating.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/skiliko-sdk/lib/modules/rating.js
// module id = 911
// module chunks = 3